// extracted by mini-css-extract-plugin
export default {"article-source":"ArticleSource_article-source__2urJD"};